import { useQuery } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getServiceProfile } from "../services/goHireService";
import { FormattedServiceProfile, ServiceProfileResponse } from "../types/serviceProfile.types";

export const useServiceProfile = (userId: number, enabled?: boolean) => {
  return useQuery<ServiceProfileResponse, Error, FormattedServiceProfile>({
    queryKey: GO_SERVICE_QUERY_KEYS.serviceProfile(userId),
    queryFn: () => getServiceProfile(userId),
    select: (response) => {
      const { rating, reviewsCount, overallJobs, id, userId: profileUserId, overview } = response.data;
      return {
        id,
        userId: profileUserId,
        overview,
        statuses: Object.entries({ rating, reviewsCount, overallJobs }).map(([key, value]) => ({
          title: key,
          value,
        })),
      };
    },
    enabled: enabled !== undefined ? enabled && !!userId : !!userId,
  });
};
